import az from '@/locales/az';
import de from '@/locales/de';
import en from '@/locales/en';
import es from '@/locales/es';
import fr from '@/locales/fr';
import ja from '@/locales/ja';
import ko from '@/locales/ko';
import ru from '@/locales/ru';
import tr from '@/locales/tr';

export default { tr, en, de, ru, es, az, fr, ko, ja } as const;
